import { useEffect } from 'react';

interface UseNewTabProps {
  skip?: boolean;
  slideId: string;
  slideRef: React.RefObject<HTMLElement>;
}

const useNewTab = ({ skip, slideId, slideRef }: UseNewTabProps) => {
  useEffect(() => {
    if (skip) return;

    const timeout = setTimeout(() => {
      if (!slideRef.current) return;
      const allATags: HTMLAnchorElement[] = Array.from(slideRef.current.getElementsByTagName('a'));

      allATags.forEach((aTag) => {
        aTag.setAttribute('target', '_blank');
        aTag.setAttribute('rel', 'noopener noreferrer');
      });
    }, 500);
    return () => clearTimeout(timeout);
  }, [skip, slideId]);
};

export default useNewTab;
